import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Spacing from "../../Spacing";
import SectionHeadingStyle3 from "../../SectionHeading/SectionHeadingStyle3";
import LoaderComponent from "../../Loader/Loader";
import { toast } from "react-hot-toast";
import { getUserBalance } from "../investments/GetUserBalance";
import { useTranslation } from "../../../hooks/useTranslation";

const WithdrawAdmin = ({ darkMode }) => {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchBalance = async () => {
      const userBalance = await getUserBalance();
      if (userBalance !== null) {
        console.log("Saldo do usuário:", userBalance);
      }
    };

    fetchBalance();
  }, []);

  const queryParams = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(queryParams.get("page")) || 1;

  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(pageFromUrl);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingActions, setLoadingActions] = useState({});

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    navigate(`/transactions?page=${newPage}&limit=10`);
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("userToken");

        if (!token) {
          toast.error(translate("withdrawAdmin.loadingTransactions"));
          return;
        }

        const response = await fetch(
          `https://getwithdrawlist-qj6yfdqbiq-uc.a.run.app`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        console.log("Resposta da API:", data);
        const pendingWithdrawals = data.withdrawals.filter(
          (withdrawal) => withdrawal.status === "pending"
        );
        setWithdrawals(pendingWithdrawals);
        setTotalPages(data.pagination.totalPages);
      } catch (error) {
        console.error("Erro ao buscar saques:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [currentPage]);

  const formatDate = (timestamp) => {
    return new Date(timestamp._seconds * 1000).toLocaleDateString();
  };

  const formatAmount = (amount) => {
    const formattedAmount = (Math.abs(amount) / 100).toFixed(2);
    return `R$${formattedAmount}`;
  };

  const handleConfirm = async (withdrawalId) => {
    setLoadingActions((prev) => ({
      ...prev,
      [`confirm-${withdrawalId}`]: true,
    }));
    try {
      const token = localStorage.getItem("userToken");

      if (!token) {
        toast.error(translate("withdrawAdmin.confirmError"));
        return;
      }

      const response = await fetch(
        `https://adminconfirmuserwithdraw-qj6yfdqbiq-uc.a.run.app`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            withdrawalId: withdrawalId,
            action: "confirm",
          }),
        }
      );

      console.log("Resposta da API:", response);

      if (response.ok) {
        const result = await response.json();
        toast.success(result.message || translate("withdrawAdmin.confirmSuccess"));
        setWithdrawals((prevWithdrawals) =>
          prevWithdrawals.filter((withdrawal) => withdrawal.id !== withdrawalId)
        );
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || translate("withdrawAdmin.confirmError"));
      }
    } catch (error) {
      console.error("Erro ao confirmar o saque:", error);
      toast.error(translate("withdrawAdmin.confirmError"));
    } finally {
      setLoadingActions((prev) => ({
        ...prev,
        [`confirm-${withdrawalId}`]: false,
      }));
    }
  };

  const handleReject = async (withdrawalId) => {
    setLoadingActions((prev) => ({
      ...prev,
      [`reject-${withdrawalId}`]: true,
    }));
    try {
      const token = localStorage.getItem("userToken");

      if (!token) {
        toast.error(translate("withdrawAdmin.rejectError"));
        return;
      }

      const response = await fetch(
        `https://adminconfirmuserwithdraw-qj6yfdqbiq-uc.a.run.app`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            withdrawalId: withdrawalId,
            action: "reject",
          }),
        }
      );

      console.log("Resposta da API:", response);

      if (response.ok) {
        const result = await response.json();
        toast.success(result.message || translate("withdrawAdmin.rejectSuccess"));
        setWithdrawals((prevWithdrawals) =>
          prevWithdrawals.filter((withdrawal) => withdrawal.id !== withdrawalId)
        );
      } else {
        const errorData = await response.json();
        toast.error(errorData.message || translate("withdrawAdmin.rejectError"));
      }
    } catch (error) {
      console.error("Erro ao reprovar o saque:", error);
      toast.error(translate("withdrawAdmin.rejectError"));
    } finally {
      setLoadingActions((prev) => ({
        ...prev,
        [`reject-${withdrawalId}`]: false,
      }));
    }
  };

  return (
    <>
      <Spacing lg="100" md="80" />
      <SectionHeadingStyle3
        title={translate("withdrawAdmin.title")}
        subTitle={translate("withdrawAdmin.subtitle")}
        variant="text-left"
        href="/withdraw-admin"
      />
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="table-responsive">
              <table className="cs_cart_table">
                <thead>
                  <tr>
                    <th style={{ width: "20%", textAlign: "center" }}>{translate("withdrawAdmin.email")}</th>
                    <th style={{ width: "20%", textAlign: "center" }}>{translate("withdrawAdmin.cpf")}</th>
                    <th style={{ width: "20%", textAlign: "center" }}>{translate("withdrawAdmin.date")}</th>
                    <th style={{ width: "20%", textAlign: "center" }}>{translate("withdrawAdmin.amount")}</th>
                    <th style={{ width: "20%", textAlign: "center" }}>{translate("withdrawAdmin.actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="5"
                        rowSpan="10"
                        style={{ textAlign: "center", padding: "50px 0" }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "570px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <LoaderComponent />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    withdrawals.map((withdrawal, index) => (
                      <tr
                        key={withdrawal.id}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "transparent" : "#242424",
                        }}
                      >
                        <td style={{ width: "20%", textAlign: "center" }}>
                          {withdrawal.userEmail}
                        </td>
                        <td style={{ width: "20%", textAlign: "center" }}>
                          {withdrawal.userCpf}
                        </td>
                        <td style={{ width: "20%", textAlign: "center" }}>
                          {formatDate(withdrawal.timestamp)}
                        </td>
                        <td style={{ width: "20%", textAlign: "center" }}>
                          {formatAmount(withdrawal.amount)}
                        </td>
                        <td style={{ width: "20%", textAlign: "center" }}>
                          <button
                            onClick={() => handleConfirm(withdrawal.id)}
                            disabled={
                              loadingActions[`confirm-${withdrawal.id}`]
                            }
                            style={{
                              background: loadingActions[
                                `confirm-${withdrawal.id}`
                              ]
                                ? "#a9a9a9"
                                : "#11C160",
                              padding: "10px 20px",
                              border: "none",
                              width: "100%",
                              display: "block",
                              color: "white",
                              fontWeight: "bold",
                              marginBottom: "10px",
                              cursor: loadingActions[`confirm-${withdrawal.id}`]
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            {loadingActions[`confirm-${withdrawal.id}`] ? (
                              <div
                                style={{
                                  marginInline: "auto",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LoaderComponent
                                  size={20}
                                  borderThickness={2}
                                  color="#FFF"
                                />
                              </div>
                            ) : (
                              translate("withdrawAdmin.confirm")
                            )}
                          </button>
                          <button
                            onClick={() => handleReject(withdrawal.id)}
                            disabled={loadingActions[`reject-${withdrawal.id}`]}
                            style={{
                              background: loadingActions[
                                `reject-${withdrawal.id}`
                              ]
                                ? "#a9a9a9"
                                : "#E83238",
                              padding: "10px 20px",
                              border: "none",
                              width: "100%",
                              display: "block",
                              color: "white",
                              fontWeight: "bold",
                              cursor: loadingActions[`reject-${withdrawal.id}`]
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            {loadingActions[`reject-${withdrawal.id}`] ? (
                              <div
                                style={{
                                  marginInline: "auto",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LoaderComponent
                                  size={20}
                                  borderThickness={2}
                                  color="#FFF"
                                />
                              </div>
                            ) : (
                              translate("withdrawAdmin.reject")
                            )}
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div
              className="cs_pagination"
              style={{
                textAlign: "center",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "30px",
              }}
            >
              <button
                onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
                className="cs_btn cs_style_1"
                style={{ width: "100px" }}
              >
                {translate("withdrawAdmin.previous")}
              </button>
              <span>
                {translate("withdrawAdmin.page")} {currentPage} {translate("withdrawAdmin.of")} {totalPages}
              </span>
              <button
                onClick={() =>
                  handlePageChange(Math.min(currentPage + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="cs_btn cs_style_1"
                style={{ width: "100px" }}
              >
                {translate("withdrawAdmin.next")}
              </button>
            </div>

            <div className="cs_height_30 cs_height_lg_30" />
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawAdmin;
